import { SET_ERROR_STATUS, CLEAR_ERROR_STATUS } from './error-page.actions';

const initialState = {
  status: null,
};

export const errorPageReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ERROR_STATUS:
      return {
        ...state,
        status: payload,
      };
    case CLEAR_ERROR_STATUS:
      return {
        ...state,
        status: null,
      };
    default:
      return state;
  }
};
